import clsx from 'clsx';
import Button from 'components/atoms/Button/Button';
import Card from 'components/atoms/Card/Card';
import Txt from 'components/atoms/Txt/Txt';
import AccountSettingsCard from 'components/molecules/AccountSettingsCard/AccountSettingsCard';
import ExploreCard from 'components/molecules/ExploreCard/ExploreCard';
import MoreSurveysBanner from 'components/molecules/MoreSurveysBanner/MoreSurveysBanner.qmee'; // Ensure to import the qmee version of MoreSurveysBanner otherwise version prop not available
import { AuthenticationContext } from 'components/templates/AuthenticationProvider/AuthenticationProvider';
import { useCountdownTimer } from 'hooks/useCountdownTimer';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import React, { MouseEvent, useContext, useState } from 'react';
import classes from './More.qmee.module.scss';
import { useMorePageQuery } from './useMorePageQuery';
import {
  PRIVACY_SETTINGS,
  PRIVACY_NOTICE,
  TERMS_AND_CONDITIONS,
  REFER,
  FAQ,
  BLOG,
  SURVEY_TIPS,
  ACCOUNT_SETTINGS,
  CONTACT_US,
} from 'components/pages/pages';

export type Props = {
  className?: string;
};

function MenuCard({
  href,
  title,
  description,
  external = false,
}: {
  href: string;
  title: string;
  description?: string;
  external?: boolean;
}) {
  const linkProps = external ? { target: '_blank', rel: 'noopener noreferrer' } : {};

  return (
    <Card isLink className={classes.menuCard}>
      <Link href={href} className={classes.menuCardLink} {...linkProps}>
        <span className={classes.menuCardTitle}>{title}</span>
        {description && <Txt className={classes.menuCardDescription}>{description}</Txt>}
      </Link>
    </Card>
  );
}

export default function More({ className }: Props) {
  const [darkMode, setDarkMode] = useState(false);
  const { logOut } = useContext(AuthenticationContext);
  const { clearCountdown } = useCountdownTimer('secondFactorCountdown');
  const { t } = useTranslation();

  const data = useMorePageQuery();

  React.useEffect(() => {
    clearCountdown();
  }, [clearCountdown]);

  function handleLogout(e: MouseEvent) {
    e.preventDefault();
    logOut('header');
  }

  function handleDarkModeToggle() {
    setDarkMode(!darkMode);
  }

  return (
    <div className={clsx(classes.root, className)}>
      <MoreSurveysBanner
        profileUrlRef={data}
        className={classes.moreSurveysBanner}
        version="more"
      />
      <div className={classes.content}>
        {/* <ExploreCard
          completedTasks={0}
          totalTasks={11}
          href="/account/explore"
          className={classes.fullWidthCard}
        /> */}

        <div className={classes.menuGrid}>
          <AccountSettingsCard href={ACCOUNT_SETTINGS.path} notificationCount={0} />
          <MenuCard href={PRIVACY_SETTINGS.path} title={t('Privacy Settings')} />
          <MenuCard href={REFER.path} title={t('Refer a friend')} />
          <MenuCard href={SURVEY_TIPS.path} title={t('Survey Tips')} />
          <MenuCard href={BLOG.path} title={t('Community Blog')} />
          <MenuCard href={FAQ.path} title={t("FAQ's")} />
          <MenuCard href={TERMS_AND_CONDITIONS.path} title={t('Terms of Service')} />
          <MenuCard href={PRIVACY_NOTICE.path} title={t('Privacy Notice')} />
          <MenuCard href={CONTACT_US.path} title={t('Contact Qmee')} />

          {/* TODO: Dark mode will be implemented in the future
          <Card className={classes.menuCard}>
            <div className={classes.darkModeCard}>
              <span className={classes.menuCardTitle}>{t('Dark Mode')}</span>
              <div className={classes.darkModeToggle}>
                <span className={classes.toggleLabel}>{darkMode ? t('ON') : t('OFF')}</span>
                <Switch
                  checked={darkMode}
                  onToggle={handleDarkModeToggle}
                  className={classes.switch}
                />
              </div>
            </div>
          </Card>*/}

          <Card isLink className={classes.menuCard}>
            <Button onClick={handleLogout} buttonType="text" className={classes.logoutButton}>
              <Txt className={classes.logoutText}>Log Out</Txt>
            </Button>
          </Card>
        </div>
      </div>
    </div>
  );
}
